import {
  BOOTSTRAP_SESSION,
  FETCH_ME,
  ME_REQUEST,
  ME_SUCCESS,
  ME_FAILURE,
  SESSION_ANONYMOUS,
  CLEAR_PROFILE,
} from "./actionTypes";

export const bootstrapSession  = () => ({ type: BOOTSTRAP_SESSION });
export const fetchMe           = () => ({ type: FETCH_ME });
export const meRequest         = () => ({ type: ME_REQUEST });
export const meSuccess         = ({ user, permissions }) => ({ type: ME_SUCCESS, payload: { user, permissions } });
export const meFailure         = (error) => ({ type: ME_FAILURE, payload: error });
export const sessionAnonymous  = () => ({ type: SESSION_ANONYMOUS });
export const clearProfile      = () => ({ type: CLEAR_PROFILE });
